export function important(value) {
    return (value + ' !important');
}
export function calculateHeight(calculation) {
    // Créez un élément div temporaire
    if (calculation === undefined) {
        calculation = '600px';
    }
    if (typeof calculation !== 'string' && calculation !== undefined) {
        calculation = calculation.toString();
    }
    const tempDiv = document.createElement('div');
    // Appliquez le calcul comme style au div
    tempDiv.style.height = calculation;
    // Ajoutez le div à la fin du corps du document
    document.body.appendChild(tempDiv);
    // Obtenez la hauteur calculée
    const calculatedHeight = parseFloat(getComputedStyle(tempDiv).height);
    // Supprimez le div temporaire du document
    document.body.removeChild(tempDiv);
    // Vérifiez si la hauteur calculée est un nombre valide
    return isNaN(calculatedHeight) ? null : calculatedHeight + 10;
}
//# sourceMappingURL=important.js.map